




















































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import rtSelect from "@/components/activityManagement/rtSelect.vue";
import rtDatePicker from "@/components/activityManagement/rtDatePicker.vue";

const activityManagementModule = namespace("activityManagement");

@Component({
  components: {
    rtSelect,
    rtDatePicker
  }
})
export default class ActivityManagement extends Vue {
  // @activityManagementModule.State("activityList") list!: any;
  // @activityManagementModule.State("activityListPage") pages!: any;
  @activityManagementModule.State("activtyStatusList") activtyStatusList!: any;
  // @activityManagementModule.State("activityListPageLoading")
  // activityListPageLoading!: boolean;
  defaultIndex: number = 2;
  activityKeyword: string = ""; /* 输入搜索 */
  statusType: string = "进行中"; /* 状态类型 */
  activityDate: string = ""; //活动有效时间
  selfStatus: boolean = false;
  finished: boolean = false;
  pages: any = {
    finished: false,
    loading: false,
    total: 0,
    pageNum: 1,
    pageSize: 10,
    couponAvailableList: []
  };
  activtyStatus: any = {
    "": "全部",
    "0": "待配置",
    "1": "进行中",
    "2": "暂停",
    "3": "已结束",
    "4": "待启动",
    "5": "已废弃"
    // '6': '待审核'
  };
  mounted() {}
  getActivityList(pageNum?: number) {
    let self = this;
    self.$store
      .dispatch("activityManagement/getActivityList", {
        activityName: self.activityKeyword, //活动名称
        activityStatus: self.statusType == "进行中" ? "1" : self.statusType, //活动状态
        startDate: self.activityDate, //有效时间
        pageNum: pageNum || self.pages.pageNum,
        pageSize: self.pages.pageSize,
        status: self.selfStatus
      })
      .then(({ success, error }) => {
        if (success) {
          self.pages.total = success.data.total;
          self.pages.loading = false;
          const _list = success.data.list.map((item: any) => {
            let _item = item;
            _item.activityStartDate = self.$format(
              _item.activityStartDate,
              "YYYY.MM.DD"
            );
            _item.activityEndDate = self.$format(
              _item.activityEndDate,
              "YYYY.MM.DD"
            );
            _item.activityStatus = self.activtyStatus[`${item.activityStatus}`];
            return _item;
          });
          if (self.pages.pageNum >= success.data.pages) {
            self.finished = true;
          }
          self.pages.pageNum = self.pages.pageNum + 1;
          self.pages.couponAvailableList = [
            ...self.pages.couponAvailableList,
            ..._list
          ];
        }
      });
  }
  handleActivityDate(value: string) {
    this.activityDate = value;
    this.pages.pageNum = 1;
    this.renderGetData();
  }
  onSearch(item: string) {
    this.activityKeyword = item;
    this.pages.pageNum = 1;
    this.renderGetData();
  }
  input(item: string) {
    this.activityKeyword = item;
    this.pages.pageNum = 1;
    console.log("123", item);
    this.renderGetData();
  }
  handleSelectTypeClick(item: string) {
    this.statusType = item;
    this.pages.pageNum = 1;
    this.renderGetData();
  }
  renderGetData() {
    this.pages.couponAvailableList = [];
    this.selfStatus = true;
    this.getActivityList();
    this.selfStatus = false;
  }
  onLoadList() {
    this.getActivityList();
  }
  goActivityDetail(item: any) {
    // if (item.activityStatus == "已废弃") {
    //   return;
    // }
    let activityId: string = item.activityId;
    let activityName: string = item.activityName;
    this.$router.push({
      path: `/activityManagement/managementDetail`,
      query: { activityId, activityName }
    });
  }
}
